import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {IoChevronDown, IoChevronUp} from 'react-icons/io5'
import {useToggle} from 'react-use'
import {mapProps} from 'recompose'
import {NullAsDefault, renderOwnChild, renderSelf, Visible,} from 'views/Shared'
import {BsCaretDownFill, BsCaretRightFill} from "react-icons/bs";
import {FaFilter} from "react-icons/fa6";

export const DefaultAdvancedToggle = ({
                                          className = 'w-full flex justify-end items-center py-1',
                                          title,
                                          onClick,
                                          expanded = false,
                                          renderTitle = renderSelf,
                                          prefixIcon,
                                          icons = [IoChevronDown, IoChevronUp],
                                      }) => {
    const t = useTranslate()
    const Component = expanded ? icons[1] : icons[0]

    return (
        <div
            className={classNames(
                className,
                expanded ? 'text-secondary-600' : 'text-color-300 hover:text-secondary'
            )}>
            <div
                onClick={onClick}
                style={{padding: '4px 10px'}}
                className="flex items-center gap-1 cursor-pointer">
                {prefixIcon}
                {renderTitle(
                    <span className="ml-1 text-doc-sm italic tracking-wide leading-tight">{t(title)}</span>
                )}
                {/*<Component size={12} style={{marginTop: 1}}/>*/}
                <BsCaretDownFill size={12} style={{marginTop: 1, transform: !!expanded ? 'rotate(180deg)' : '', transition: 'transform 0.3s', }}/>
            </div>
        </div>
    )
}

export const ButtonAdvance = ({disabled, onClick, expanded, hasAdvancedFilters}) => {
    return (
        <button
            disabled={disabled}
            type="button"
            onClick={() => onClick((v) => !v)}
            style={{
                width: 40,
                height: 40,
                borderRadius: '0.65rem',
                cursor: disabled ? 'not-allowed' : 'pointer',
                position: 'relative'
            }}
            className={classNames(
                "flex flex-center transition-all border duration-300",
                disabled ? 'background-200 border border-color-100 text-color-500' :
                    (expanded || hasAdvancedFilters) ?
                        'bg-secondary-700 border-secondary-700 text-white' :
                        'hover:scale-96 bg-secondary-50 hover:bg-secondary-100 border-secondary-400 hover:border-secondary-700 text-secondary-700'
            )}>
            <FaFilter size={16} className="transition-transform duration-200"/>
            {hasAdvancedFilters && (
                <span style={{top: -3, right: -3}}
                      className="w-3 h-3 rounded-full bg-primary border-2 border-white absolute"/>
            )}
        </button>
    )
}

export const ExpandablePanel = ({
                                    prefixIcon,
                                    icons,
                                    style,
                                    children,
                                    className,
                                    renderTitle,
                                    onClick = NullAsDefault,
                                    expanded = false,
                                    Header = ButtonAdvance,
                                    Wrapper = renderOwnChild,
                                    title = 'advanced settings',
                                    renderCollapsedContent = NullAsDefault,
                                    ContentWrapper = renderOwnChild,
                                }) => {
    const t = useTranslate()
    const renderWrapper = useCallback(
        (child) => (
            <Wrapper
                {...{
                    style,
                    onClick,
                    className,
                }}>
                {child}
            </Wrapper>
        ),
        []
    )

    const hasValue = _.some(Object.values(children), Boolean)

    if (!hasValue) {
        return (
            <div style={{'--filter-advance-border': 'var(--color-secondary)'}} className="flex flex-col mass-time-filter-advance">
                <div className="p-2 background-200 rounded-md text-color-300 italic tracking-wider">
                    * {t('no advanced filters have been set yet')}
                </div>
            </div>
        )
    }

    return renderWrapper(
        <React.Fragment>
            {/*<Header*/}
            {/*    {...{*/}
            {/*        title,*/}
            {/*        prefixIcon,*/}
            {/*        icons,*/}
            {/*        onClick,*/}
            {/*        expanded,*/}
            {/*        renderTitle,*/}
            {/*    }}*/}
            {/*/>*/}
            {/*{!!expanded ? (*/}
            {/*    <div className="flex flex-col mass-time-filter-advance">{children}</div>*/}
            {/*) : (*/}
            {/*    renderCollapsedContent(<div className="flex flex-col mass-time-filter-advance">{children}</div>)*/}
            {/*)}*/}
            {!!expanded && (
                <div style={{'--filter-advance-border': 'var(--color-secondary)'}} className="flex flex-col mass-time-filter-advance">
                    {!hasValue && (
                        <div className="px-3 py-2 bg-slate-50 rounded-xl space-x-1">
                            <span className="font-semibold text-slate-500 flex-shrink-0">
                                {`* ${t('recommendations')} : `}
                            </span>
                            <span className="text-slate-400">
                                {t('filter advance description')}
                            </span>
                        </div>
                    )}
                    {children}
                </div>
            )}
        </React.Fragment>
    )


}

const AdvancedFormGroup = ({groupValues, Wrapper = renderOwnChild}) => {
    const [isToggle, toggle] = useToggle(false)

    const formSchema = Array.from(groupValues || []).filter(Visible)

    if (_.isEmpty(formSchema)) return null

    return (
        <ExpandablePanel
            onClick={toggle}
            Wrapper={Wrapper}
            expanded={isToggle}>
            <div className="space-y-3">
                <FieldsFactory formSchema={formSchema}/>
            </div>
        </ExpandablePanel>
    )
}

export const AdvancedFormFields = ({
                                       formSchema,
                                       Wrapper = renderOwnChild,
                                       ...props
                                   }) => {
    const [isToggle, toggle] = useToggle(false)

    if (_.isEmpty(formSchema)) return null

    return (
        <ExpandablePanel
            onClick={toggle}
            Wrapper={Wrapper}
            expanded={isToggle}
            {...props}>
            <div className="space-y-3">
                <FieldsFactory formSchema={formSchema}/>
            </div>
        </ExpandablePanel>
    )
}

export const withAdvancedOptions = (options) => (Component) =>
    mapProps(({name, value, onChange, disabled}) => ({
        name,
        value,
        options,
        onChange,
        disabled,
    }))(Component)

export default AdvancedFormGroup
